import React from "react"
import styled from "styled-components"
import DefaultButton from "lib/Button"
import { lighten, desaturate } from "polished"
import { siteTheme as theme } from "theme"

const StyledButton = styled(DefaultButton)<IButton>`
  border: ${(props) => theme.buttonStyles[props.variant].border};
  transition: all ease-out 0.15s;
  white-space: nowrap;

  &:focus {
    outline: none;
    box-shadow: ${theme.inputFocusShadow};
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }

  ${(props) =>
    props.invert
      ? `
          background: ${theme.buttonStyles[props.variant].color};
          color: ${theme.buttonStyles[props.variant].background};


          &:focus {
            ${
              props.variant === "transparent"
                ? ``
                : `
                    box-shadow: inset 0 0 2px ${desaturate(
                      0.1,
                      theme.buttonStyles[props.variant].background
                    )};
                  `
            }

          }

        `
      : `
          background: ${theme.buttonStyles[props.variant].background};
          color: ${theme.buttonStyles[props.variant].color};

          &:focus {
            box-shadow: inset 0 -2px 4px ${
              theme.buttonStyles[props.variant].background
            };
          }
        `}

  &:hover:not(:disabled) {
    ${(props) =>
      props.variant !== "transparent"
        ? `
        ${
          props.invert
            ? `
              background: ${lighten(
                0.1,
                theme.buttonStyles[props.variant].color
              )};
              color: ${lighten(
                0.1,
                theme.buttonStyles[props.variant].background
              )};
            `
            : `
            background: ${lighten(
              0.1,
              theme.buttonStyles[props.variant].background
            )};
            color: ${lighten(0.1, theme.buttonStyles[props.variant].color)};
          `
        }`
        : ``}
  }

  span {
    justify-content: center;
  }
`

const StyledIconButton = styled(DefaultButton)`
  background: none;
  padding: 0;
  color: ${theme.colors.black};

  svg {
    color: currentColor;
  }
`

type ButtonVariant =
  | "primary"
  | "secondary"
  | "danger"
  | "default"
  | "transparent"
  | "icon"

type ButtonSize = "sm" | "md" | "lg"

export interface IButton {
  variant: ButtonVariant
  invert?: boolean
  size?: ButtonSize
  children: React.ReactNode
  onClick?: (...args) => void
  icon?: boolean | "left" | "right"
}

const Button: React.FC<
  IButton & React.ButtonHTMLAttributes<JSX.IntrinsicAttributes>
> = ({ children, variant = "default", ...props }) => {
  return variant === "icon" ? (
    <StyledIconButton {...props}>{children}</StyledIconButton>
  ) : (
    <StyledButton variant={variant} {...props}>
      {children}
    </StyledButton>
  )
}

export { Button }
